const messages = {
  bonus: {
    title: "Panoramica crediti bonus",
    description:
      "I bonus in euro vengono assegnati alle aziende partecipanti in base ai dati di vendita inviati.",
    lastMonth: "Mese scorso",
    currentMonth: "Mese in corso",
    totalCurrentYear: "Totale anno in corso",
    totalLastYear: "Totale anno precedente",
  },
  points: {
    title: "Panoramica crediti punti",
    period: "Anno civile in corso ({year})",
    totalAwarded: "Totale punti assegnati",
    redeemed: "Punti riscattati",
    totalBalance: "Saldo punti totale",
    redemptionRate: "Punti riscattati come percentuale dei punti assegnati",
    averageAwarded: "Media dei punti assegnati per pneumatico acquistato",
    standardAwarded: "Punti netti dalle righe di vendita calcolate, resi inclusi",
    bsPlusInclBooster: "Punti dalle righe di vendita con quantità positiva",
    perTire: "Punti riscattati per pneumatico acquistato",
  },
  tires: {
    title: "Panoramica quantità pneumatici",
    description: "Pneumatici acquistati dai clienti",
    prevMonth: "Mese precedente",
    totalLastYear: "Totale anno precedente",
    purchaseIndirect: "Acquisti tramite grossista (indiretto)",
    purchaseDirect: "Acquisti tramite grossista (diretto)",
    totalCurrentYear: "Totale anno in corso",
    currentMonth: "Mese in corso",
  },
  participating: {
    title: "Clienti partecipanti",
    description:
      "Le aziende che si registrano su BRIDGESTONE PLUS possono essere associate tramite il numero cliente.",
    total: "Totale",
    newThisMonth: "Nuovi questo mese",
    newThisYear: "Nuovi quest'anno",
    createdInCurrentMonth: "Creati nel mese corrente (dall'admin)",
    loginsCurrentYear: "Accessi nell'anno (dopo accettazione T&C)",
  },
  brand: {
    title: "Marca",
    description: "I tuoi acquisti nel dettaglio",
    centerTitle: "Per\nmarca",
  },
  rim: {
    title: "Cerchio",
    centerTitle: "Per dimensione\ndel cerchio",
  },
  tireGoals: {
    title: "Obiettivi acquisti pneumatici",
    subtitle: "Ottieni punti per i tuoi acquisti di pneumatici.",
    centerTitle: "Per\nmisura del pneumatico",
    tiresRemaining: "Pneumatici rimanenti",
    progressionTarget: "Progresso verso l'obiettivo:",
    pointsEarnedPurchases: "punti guadagnati\nsui tuoi\nacquisti",
    pointsEarnedBoosters: "punti guadagnati\ncon i\nbooster",
    purchasesDetail: "I tuoi acquisti nel dettaglio",
    cta: "Scopri di più sui tuoi punti",
    pointsTitle: "I tuoi punti",
    pointsSubtitle: "Punti guadagnati con gli acquisti Bridgestone",
    achievementsTitle: "I tuoi risultati",
    achievementsSubtitle: "Il tuo impegno annuale:",
    achievementsSubtitle2: "pneumatici",
  },
  score: {
    title: "Punteggio",
    total: "Totale",
    credits: "Accrediti in",
    deductions: "Detrazioni in",
        unlockedPoints: "Punti sbloccati",
        pendingPoints: "Punti in sospeso",
  },
  score_extended: {
    title1: "Saldo punti",
    title2: "Bonus in euro",
    balance: "Saldo punti",
    bonus_in_euro: "Bonus in euro",
    date: "Data",
    added_points: "Punti aggiunti in",
    total_bands: "Totale fasce",
    goal: "Obiettivo",
    tyres_previous_year: "Pneumatici venduti lo scorso anno",
    tyres_current_year: "Pneumatici venduti quest'anno",
    target_this_year: "Obiettivo di vendita quest'anno",
    bonus_this_year: "Bonus guadagnato (€)",
    loyal_minimum: "Livello minimo di fidelizzazione",
    bonus_multiplier: "Moltiplicatore bonus",
  },
  lastImport: {
    label: "Ultimo import dei dati di vendita:",
    on: "il",
  },
  wholesalerTable: {
    title: "Clienti partecipanti nel dettaglio",
    description:
      "Di seguito trovi le aziende che si sono registrate su BRIDGESTONE PLUS con il numero cliente della tua azienda. Puoi usare i filtri per ordinare o la ricerca per trovare clienti specifici.",
    columns: {
      customer_number: "N. cliente",
      address_company_name: "Azienda",
      address_street: "Via e numero",
      address_postal_code: "CAP",
      address_city: "Città",
      last_registration: "Ultima registrazione",
      network: "Rete",
      profile_group: "Gruppo",
      tires_amount: "Numero pneumatici",
      point_balance: "Saldo punti",
      bonus: "Bonus",
      details: "Dettagli",
    },
    searchPlaceholder: "Cerca",
  },
  dealerTable: {
    columns: {
      date: "Data",
      wholesaler_bs_plus: "Grossista BS+",
      customer_number: "Numero cliente",
      article: "Articolo",
      brand: "Marca",
      product: "Prodotto",
      type: "Tipo",
      inch: "Pollici",
      season: "Stagione",
      amount: "Quantità",
      points: "Punti",
      activity: "Attività",
      total_points: "Totale punti",
    },
    title: "Tabella distributori",
    description: "Panoramica delle attività dei distributori",
  },
  business_units: {
    title: "Unità di business",
    centerTitle: "Per\nunità",
  },
  season: {
    title: "Stagione",
    centerTitle: "Per periodo\ndell'anno",
  },
};

export default {
  messages,
};
